import React from 'react';
import styled from 'styled-components';
import LabelText from './LabelText';
import CheckIcon from '@mui/icons-material/Check';

interface RadioButtonProps {
  label: string;
  name?: string;
  value: string;
  checked: boolean;
  onChange?: (event: any) => void;
}

const RadioWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

`;

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  
`;

const StyledRadio = styled.div<{ checked: boolean }>`
  cursor: pointer;
  display: inline-block;
  width: 20px;
  height: 20px;
  // background: ${props => (props.checked ? 'salmon' : 'white')};
  border-radius: 50%;
  border: 1px solid ${({ checked, theme }) => (checked ? '#00D1A8' : theme.NumberColor)};
transition: all 150ms;
  ${HiddenRadio}: focus + & {
  box- shadow: 0 0 0 3px pink;
  }
  ${HiddenRadio}: checked + & {
  background: #00D1A8;
}
  `;



const RadioButton: React.FC<RadioButtonProps> = ({ label, name, value, checked, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <RadioWrapper  >
      <HiddenRadio
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
      />
      <StyledRadio checked={checked}>
        {checked && <CheckIcon style={{ fontSize: 17, color: 'black', paddingLeft: '1px' }} />}
      </StyledRadio>
      <LabelText>{label}</LabelText>
    </RadioWrapper>
  );
};

export default RadioButton;
